
import { BlockedCompany } from "@/hooks/useBlockedCompanies";
import { Button } from "@/components/ui/button";
import { useBlockedCompanies } from "@/hooks/useBlockedCompanies";
import { useState } from "react";
import { UnblockCompanyDialog } from "./UnblockCompanyDialog";

interface BlockedCompaniesListProps {
  companies: BlockedCompany[];
  isLoading: boolean;
}

const formatDate = (date: string) => {
  return new Date(date).toLocaleDateString();
};

export const BlockedCompaniesList = ({ companies, isLoading }: BlockedCompaniesListProps) => {
  const { unblockCompany } = useBlockedCompanies(undefined);
  const [selectedCompany, setSelectedCompany] = useState<BlockedCompany | null>(null);
  const [showUnblockDialog, setShowUnblockDialog] = useState(false);

  const handleUnblock = (company: BlockedCompany) => {
    setSelectedCompany(company);
    setShowUnblockDialog(true);
  };

  const handleConfirmUnblock = () => {
    if (selectedCompany) {
      unblockCompany.mutate(selectedCompany.id);
      setShowUnblockDialog(false);
      setSelectedCompany(null);
    }
  };

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (companies.length === 0) {
    return <div>No companies blocked yet.</div>;
  }

  return (
    <>
      <div className="space-y-4">
        {companies.map((company) => (
          <div 
            key={company.id} 
            className="p-4 border rounded-lg bg-white shadow-sm flex justify-between items-center"
          >
            <div>
              <h3 className="font-medium">{company.company_name}</h3>
              <p className="text-sm text-gray-600">Domain: {company.domain}</p>
              <p className="text-sm text-gray-500">Blocked on: {formatDate(company.created_at)}</p>
            </div>
            <Button
              variant="outline"
              size="sm"
              className="text-red-600 hover:text-red-700 hover:bg-red-50"
              onClick={() => handleUnblock(company)}
            >
              Unblock Company
            </Button>
          </div>
        ))}
      </div>

      <UnblockCompanyDialog
        company={selectedCompany}
        open={showUnblockDialog}
        onOpenChange={setShowUnblockDialog}
        onConfirm={handleConfirmUnblock}
      />
    </>
  );
};
